/* ArcGIS layer ids must not contain `::`; Redux active layer ids use that separator. */
export function toActiveDefectMapLayerId(layerId: string): string {
  return layerId.replace(/::/g, '--');
}

export function fromActiveDefectMapLayerId(mapLayerId: string): string {
  return mapLayerId.replace(/--/g, '::');
}

export function normalizeActiveDefectMapLayerId(
  mapLayerId: string | null | undefined,
): string | null {
  if (!mapLayerId) {
    return null;
  }
  // Crackmap WFS swaps use `__pending` or `__pending_<token>` while the next
  // GeoJSONLayer paints under the previous extent layer.
  return mapLayerId.replace(/__pending(?:_[\w-]+)?$/, '');
}

export function isActiveDefectMapLayerId(
  mapLayerId: string | null | undefined,
  activeLayerIds: readonly string[],
): boolean {
  const normalized = normalizeActiveDefectMapLayerId(mapLayerId);
  if (!normalized) {
    return false;
  }

  return activeLayerIds.some(
    (layerId) => toActiveDefectMapLayerId(layerId) === normalized,
  );
}
